import { motion, AnimatePresence } from 'framer-motion';
import { Check, Minus } from 'lucide-react';

/**
 * Loyiha uslubidagi custom checkbox (native input o'rniga).
 * @param {{ checked: boolean, indeterminate?: boolean, onChange: () => void, title?: string, id?: string, disabled?: boolean, className?: string }} props
 */
export default function Checkbox({ checked, indeterminate = false, onChange, title, id, disabled = false, className = '' }) {
    const active = checked || indeterminate;
    return (
        <button
            type="button"
            role="checkbox"
            id={id}
            aria-checked={indeterminate ? 'mixed' : checked}
            aria-label={title}
            title={title}
            disabled={disabled}
            onClick={(e) => { e.stopPropagation(); onChange?.(); }}
            className={`relative w-[18px] h-[18px] flex-shrink-0 inline-flex items-center justify-center rounded-md border transition-all duration-150
                focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40
                ${active
                    ? 'bg-brand border-brand text-inverse shadow-brand-sm'
                    : 'bg-surface border-border hover:border-brand/60'}
                ${disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}
                ${className}`}
        >
            <AnimatePresence initial={false}>
                {active && (
                    <motion.span
                        key={indeterminate ? 'minus' : 'check'}
                        initial={{ scale: 0.4, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.4, opacity: 0 }}
                        transition={{ duration: 0.12 }}
                        className="absolute inset-0 flex items-center justify-center"
                    >
                        {indeterminate
                            ? <Minus className="w-3 h-3" strokeWidth={3} />
                            : <Check className="w-3 h-3" strokeWidth={3} />}
                    </motion.span>
                )}
            </AnimatePresence>
        </button>
    );
}
